export const navigateCMSpage = (urlkey) => {
  const atag = document.createElement('a')
  atag.href = `${import.meta.env.VITE_ADMIN_BASE_URL}/cms/` + urlkey // todo -> .env url of admin panel;
  atag.target = '_blank'
  atag.click()
}
export const navigatetoHome = (urlkey) => {
  const atag = document.createElement('a')
  atag.href = urlkey
  atag.click()
}
